import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { Body, Footer, Popup } from '@calendly/ui/components/popup';
import { isRecapPublic } from 'features/recaps/constants';
const footerCss = "fqkgc32";
const getCopy = (pendingAccessLevel, recipientCount) => {
  if (isRecapPublic(pendingAccessLevel)) {
    return {
      title: I18n.t('publisher.meeting_recap.share_modal.access_level_confirmation.make_public.title'),
      body: I18n.t('publisher.meeting_recap.share_modal.access_level_confirmation.make_public.body', {
        count: recipientCount
      }),
      back: I18n.t('publisher.meeting_recap.share_modal.access_level_confirmation.make_public.back'),
      confirm: I18n.t('publisher.meeting_recap.share_modal.access_level_confirmation.make_public.confirm')
    };
  }
  return {
    title: I18n.t('publisher.meeting_recap.share_modal.access_level_confirmation.make_private.title'),
    body: I18n.t('publisher.meeting_recap.share_modal.access_level_confirmation.make_private.body', {
      count: recipientCount
    }),
    back: I18n.t('publisher.meeting_recap.share_modal.access_level_confirmation.make_private.back'),
    confirm: I18n.t('publisher.meeting_recap.share_modal.access_level_confirmation.make_private.confirm')
  };
};
export const AccessLevelConfirmationModal = ({
  pendingAccessLevel,
  isOpen,
  onClose,
  onConfirm,
  isSubmitting = false,
  recipientCount = 0
}) => {
  const copy = pendingAccessLevel ? getCopy(pendingAccessLevel, recipientCount) : null;
  const handleConfirm = async () => {
    const didConfirm = await onConfirm();
    if (didConfirm !== false) {
      onClose();
    }
  };
  return <Popup isOpen={isOpen} onClose={onClose} size="small" title={copy?.title ?? ''}>
      {copy ? <>
          <Body>
            {copy.body}
          </Body>
          <Footer className={footerCss}>
            <Button decoration="secondary-outline" onClick={onClose} disabled={isSubmitting} wide>
              {copy.back}
            </Button>
            <Button onClick={handleConfirm} loading={isSubmitting} wide>
              {copy.confirm}
            </Button>
          </Footer>
        </> : null}
    </Popup>;
};

require("./access_level_confirmation_modal.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./access_level_confirmation_modal.js");